import bannerApi from "../api/banner-api";

const add = async (payload) => {
    const resp = await bannerApi.add(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const edit = async (payload) => {
    const resp = await bannerApi.edit(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const remove = async (payload) => {
    const resp = await bannerApi.remove(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const search = async (condition, pagination) => {
	try {
		const result = await bannerApi.search(condition, pagination);
		return { list: result.list, pagination: result.paginable };
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const saveDisplay = async (payload) => {
    const resp = await bannerApi.saveDisplay(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const getDisplay = async () => {
    const resp = await bannerApi.getDisplay();
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const bannerService = {
    add,
    edit,
    remove,
    search,
    saveDisplay,
    getDisplay
};

export default bannerService;